(function() {
    Routes = Routes || {};

    Routes.backbone = {
        photowall_path: 'photowall',
        horizontal_path: 'horizontal'
    };

    //Private function for backbone routing
    Routes.returnRoute = function(route) {
        return route.insertAt(0, '#');
    };


    Routes.distillery_analytics_album_path = function(id, name) {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryUrlAnalyticsAlbums + "/" + id + "/" + name + '?api_key=' + this.currentUser.single_access_token;
    };
    Routes.distillery_accounts_album_path = function(id, name) {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryUrlAnalyticsAccounts + "/" + id + "/" + name + '?api_key=' + this.currentUser.single_access_token;
    };
    Routes.distillery_analytics_location_path = function() {
        this.setDefaults();
        return this.config.distilleryAnalyticsUrl + 'v1/albums/' + this.currentAlbum.id + '/locations?api_key=' + this.currentUser.single_access_token;
    };
    Routes.photos_album_add_path = function(user_id, id) {
        this.setDefaults();
        return this.config.pixleePhotosServer + user_id + '/' + id + '/add';
    };
    Routes.photowall_item_path = function(id) {
        return this.returnRoute(Routes.backbone.photowall_path + '/' + id);
    };
    Routes.horizontal_item_path = function(id) {
        return this.returnRoute(Routes.backbone.horizontal_path + '/' + id);
    };
    Routes.settings_item_path = function(name) {
        return this.returnRoute(Routes.backbone.settings_path + '/' + name);
    };
    Routes.analytics_item_path = function(id) {
        return this.returnRoute(Routes.backbone.analytics_path + '/' + id);
    };
    Routes.analytics_item_details_path = function(id, name) {
        return Routes.backbone.analytics_path + '/' + id + '/' + name;
    };

    Routes.analytics_accounts_details_path = function(name) {
        return Routes.backbone.analytics_path + '/' + name;
    };
    Routes.albums_item_path = function(id) {
        return this.returnRoute('albums/' + id);
    };
    Routes.inbox_item_path = function(id) {
        return this.returnRoute('inbox/' + id);
    };
    Routes.album_settings_path = function(id) {
        return this.returnRoute('albums/settings/' + id);
    };
    Routes.album_publish_path = function(id) {
        return this.returnRoute('albums/publish/' + id);
    };
    Routes.album_collect_path = function(id) {
        return this.returnRoute('albums/collect/' + id);
    };
    Routes.distillery_albums_path = function() {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryUrlMyAlbums + '?api_key=' + this.currentUser.single_access_token;
    };
    Routes.distillery_inbox_path = function(id) {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryInboxUrl + '?api_key=' + this.currentUser.single_access_token;
    };
    Routes.distillery_photo_path = function(id) {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryPhotoUrl + '?api_key=' + this.currentUser.single_access_token + '&album_photo_id=' + id;
    };
    Routes.distillery_photo_crud_path = function(id) {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryPhotoCrudUrl + '/' + id + '?api_key=' + this.currentUser.single_access_token;
    };
    Routes.distillery_widgets_path = function() {
        this.setDefaults();
        return this.config.distilleryUrl + this.config.distilleryQueryUrl + '?api_key=' + this.currentUser.single_access_token + '&updated_at=' + this.currentAlbum.filtersort_cache_updated_at;
    };
    Routes.distillery_tag_albums_path = function() {
        this.setDefaults();
        return this.config.distilleryUrl + gon.global.distilleryTagAlbumsUrl + '?api_key=' + this.currentUser.single_access_token;
    }
    Routes.distillery_products_path = function() {
        this.setDefaults();
        return this.config.distilleryUrl + gon.global.distilleryProductsUrl + '?api_key=' + this.currentUser.single_access_token;
    }
    Routes.setDefaults = function() {
        if (this.config == null) {
            this.config = Pixlee.config.toJSON();
        }
        Routes.setDefaultUser();
    };
    Routes.setDefaultUser = function() {
        if (this.currentUser == null) {
            this.currentUser = Pixlee.currentUser.toJSON();
        }
        if (this.currentAlbum == null) {
            this.currentAlbum = Pixlee.request('get:current:album').toJSON();
        }
    };

    Routes.social_login_path = function(social_platform, widget, finger_print) {
        return '/auth/' + social_platform + '?widget=' + widget + '&state=' + finger_print;
    };


    Routes.linkTo = function(baseUrl, url, options) {
        if (options == null) {
            options = {};
        }
        _.defaults(options, {
            https: false,
            backbone: false
        });
        if (options.https) {
            baseUrl.replace('http://').replace('https://');
        }
        if (options.backbone) {
            url = '#' + url;
        }
        return baseUrl + url;
    };
})();
